/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pit-page-header__content[_ngcontent-%COMP%]{text-align:center;background-color:#243462;height:60px;width:100%}.pit-page-header__btn[_ngcontent-%COMP%]{display:flex;align-items:center;min-width:0;padding:4px 80px 4px 0;box-shadow:none;background:0 0}.pit-page-header__btn[_ngcontent-%COMP%]:hover{opacity:1}.pit-page-header__btn[_ngcontent-%COMP%]   .pit-page-header__btn_icon[_ngcontent-%COMP%]{width:32px;height:32px;opacity:.4}\n/*# sourceMappingURL=pit-page-header.component.css.map*/"];
export { styles as styles };
